<template>
  <b-alert variant="danger">
    <ul class="mb-1 errorClass">
      <li v-for="(error, index) in errors" :key="index">
        {{ error }}
      </li>
    </ul>
  </b-alert>
</template>

<script>
export default {
  name: 'Errors',

  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped>
.errorClass {
  padding-left: 17px;
}
</style>
